module.exports = __webpack_public_path__ + "img/JQ.14447d04.png";